<script setup>
import {onMounted} from 'vue'
import {useRoute} from "vue-router";
import {aliPayLink} from "@/api/common"

const route = useRoute();
onMounted(() => {

  const orderNo = route.query.orderNo; // 获取 URL 参数
  console.log('orderNo:', orderNo);
  aliPayLink(orderNo).then(res => {
    if (res.status == 200 && res.data && res.data.code == 0) {
      console.log('res.data.data:', res.data.data);
      window.location.href = res.data.data; // 重定向到支付链接
    }
  })
});
</script>

